import axios from 'axios'
import store from '@/store'
import showToast from '@/utils/toast'
import getMonitorSerial from "@/utils/trans";
import router from "@/router";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// NProgress 配置（颜色用你全站变量，暗黑模式自动适配）
NProgress.configure({
    showSpinner: false, // 不要右上角那个小转圈，只留顶部细条
    trickleSpeed: 200,
    minimum: 0.08,
})

const service = axios.create({
    baseURL: '/api-laputa',
    timeout: 10000,
    withCredentials: true, // 必须开启，携带HttpOnly Cookie
})

let isRefreshing = false
let requestQueue = []

// ========== 新增：请求计数器，解决并发请求时进度条闪烁 ==========
let pendingCount = 0
const startLoading = () => {
    pendingCount++
    NProgress.start()
}
const doneLoading = () => {
    pendingCount = Math.max(0, pendingCount - 1)
    if (pendingCount === 0) {
        NProgress.done()
    }
}

// 请求拦截器
service.interceptors.request.use(config => {
    config.headers['TransIdo'] = getMonitorSerial()
    const token = sessionStorage.getItem("laputa-token");
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    // ========== 新增：开始进度条 ==========
    // 支持单个接口跳过：service.get('/xxx', { loading: false })
    if (config.loading !== false) {
        startLoading()
    }
    return config
})

// 响应拦截器
service.interceptors.response.use(
    res => {
        // ========== 新增：结束进度条 ==========
        if (res.config?.loading !== false) doneLoading()
        return res
    },
    async err => {
        // ========== 新增：错误也要结束进度条，不然会卡住 ==========
        if (err.config?.loading !== false) doneLoading()

        const originalConfig = err.config
        if (originalConfig._retry) {
            return Promise.reject(err)
        }
        const router = require('@/router').default
        if (err.response?.status === 403) {
            await router.push('/403')
            return
        }
        // http 401，排除刷新接口本身，防止死循环
        if (err.response?.status === 401 && originalConfig.url !== '/v1/api/refresh') {
            if (isRefreshing) {
                return new Promise(resolve => {
                    requestQueue.push((newToken) => {
                        originalConfig.headers.Authorization = `Bearer ${newToken}`
                        resolve(service(originalConfig))
                    })
                })
            }
            isRefreshing = true
            try {
                // 调用刷新token接口，浏览器自动带上cookie
                await store.dispatch('userInfo/refresh')
                const newAccessToken = sessionStorage.getItem("laputa-token")
                // 重放队列所有请求
                requestQueue.forEach(cb => cb(newAccessToken))
                requestQueue = []
                // 打上重试标记，该请求只允许重试1次
                originalConfig._retry = true
                // 重试原来失败请求
                originalConfig.headers.Authorization = `Bearer ${newAccessToken}`
                return service(originalConfig)
            } catch (e) {
                //清空权限菜单
                showToast(e.message)
                setTimeout(() => {
                    location.href = '/login'
                }, 500)
                return Promise.reject(e)
            } finally {
                isRefreshing = false
            }
        }
        return Promise.reject(err)
    }
)

export default service
